import Vue from "vue";
import App from "./App.vue";
import AppPc from "./AppPc.vue";
import router from "./router";

import store from "@/store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import ElementUI from "element-ui";
import iView from "iview";
import vueRouter from "vue-router";

import VueLazyload from "vue-lazyload";
import { /* isWeixin, */ parseQuery, isH5 } from "@utils";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Share from "vue-social-share";
import "vue-social-share/dist/client.css";
import VueClipboard from "vue-clipboard2";
import VueDragResize from "vue-drag-resize";

Vue.use(ElementUI);
Vue.use(animate);
Vue.use(Share);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(iView);
Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.component("vue-drag-resize", VueDragResize);
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
//let wx = require("weixin-js-sdk");
//wx.config({
//   debug: false,
//   appId: "wxe3ef649b059a33ca",
//   timestamp: "",
//   nonceStr: "",
//   signature: "",
//   jsApiList: ["wx-open-launch-weapp"],
//   openTagList: ["wx-open-launch-weapp"]
// });
const _isH5 = isH5();
// PC端加载
if (!_isH5) {
  import("iview/dist/styles/iview.css");
  import("@assets/pc/font/iconfont.css");
  import("@assets/pc/css/style.styl");
  import("@assets/pc/css/reset.css");
  import("element-ui/lib/theme-chalk/index.css");

  router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    if (to.name === "Login") {
      localStorage.setItem("login_back_url", from.fullPath);
    }
    next();
  });

  router.afterEach(() => {
    iView.LoadingBar.finish();
  });

  const originalPush = vueRouter.prototype.push;
  vueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
  };
} else {
  import("element-ui/lib/theme-chalk/index.css");
  import("@assets/moblie/css/reset.css");
  import("@assets/moblie/iconfont/iconfont");
  import("@assets/moblie/iconfont/iconfont.css");
  import("@assets/moblie/js/media_750");
  import("vue-ydui/dist/ydui.base.css");
  import("@assets/moblie/css/base.css");
  import("@assets/moblie/css/style.css");

  Vue.config.devtools = process.env.NODE_ENV !== "production";
  Vue.prototype.$validator = function(rule) {
    return new schema(rule);
  };
  Vue.prototype.$scroll = $scroll;
  Vue.prototype.$dialog = dialog;

  const CACHE_KEY = "clear_0.0.1";

  if (!cookie.has(CACHE_KEY)) {
    cookie.clearAll();
    cookie.set(CACHE_KEY, 1);
  }

  let cookieName = "VCONSOLE";
  let query = parseQuery();
  let urlSpread = query["spread"];
  let vconsole = query[cookieName.toLowerCase()];
  let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
  let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式

  if (urlSpread !== undefined) {
    var spread = cookie.get("spread");
    urlSpread = parseInt(urlSpread);
    if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
      cookie.set("spread", urlSpread || 0);
    } else if (spread === 0 || typeof spread !== "number") {
      cookie.set("spread", urlSpread || 0);
    }
  }

  // const _isWechat = isWeixin();

  if (vconsole !== undefined) {
    if (vconsole === md5UnCrmeb && cookie.has(cookieName))
      cookie.remove(cookieName);
  } else vconsole = cookie.get(cookieName);

  if (vconsole !== undefined && vconsole === md5Crmeb) {
    cookie.set(cookieName, md5Crmeb, 3600);
    // const module = () => import("vconsole");
    /*module().then(Module => {
      new Module.default();
    });*/
  }

  // if (_isWechat) {
  //   const module = () => import("@libs/wechat");
  //   module()
  //     .then(Module => {
  //       console.log(Module);
  //       Module.default()
  //         .then(() => Module.oAuth())
  //         .catch(e => {
  //           console.log(e);
  //           dialog.error("授權失敗，請重新嘗試");
  //         });
  //     })
  //     .catch(e => {
  //       console.log(e);
  //       dialog.error("授權失敗，請重新嘗試");
  //     });
  // }
}
const $vm = _isH5
  ? new Vue({ router, store, render: h => h(App) })
  : new Vue({ router, store, render: h => h(AppPc) });

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
